export default "__VITE_ASSET__0a800962__"